import React, { useState, useRef } from "react"

import EditProfile from "@/components/AccountSettings/v1/EditProfile"

import {
  addDataLayerEditProfileClose,
  eventInfo,
} from "@/components/AccountSettings/v1/Profile/analytics"

import profileStyle from "@/components/AccountSettings/v1/Profile/index.module.scss"

const Profile = ({
  i18n = {},
  data = {},
  userType = [],
  businessList = [],
  onEditProfile = () => {},
  ...props
}) => {
  const [showModal, setShowModal] = useState(false)
  const editMyInfo = useRef(null)

  const handleModalPopup = () => {
    setShowModal(true)
  }

  const onModalClose = () => {
    editMyInfo.current.focus()
    setShowModal(false)
    addDataLayerEditProfileClose()
  }

  return (
    <React.Fragment>
      <div className={`account-profile ${profileStyle?.profileStyleWrapper}`}>
        <div className="account-settings__section-header">
          <h2 className="account-settings__section-title">
            {i18n?.accountProfile}
          </h2>
          <div
            className="account-profile__edit gbh-data-layer"
            ref={editMyInfo}
            data-gbh-data-layer={eventInfo}
            role="button"
            tabIndex="0"
            onClick={handleModalPopup}
          >
            {i18n?.edit}
          </div>
        </div>
        <EditProfile
          show={showModal}
          onModalClose={onModalClose}
          i18n={i18n}
          data={data}
          userType={userType}
          businessList={businessList}
          onEdit={onEditProfile}
          {...props}
        />
        <div className="row account-profile__content account-professionals">
          {data?.custom?.fields?.businessType &&
            data?.custom?.fields?.businessType !== "Consumer" && (
              <>
                <div className="professional_account">
                  {i18n?.professionalAccount}
                </div>
                <div className="col-12 account-profile__container account-professional">
                  <div className="account-profile__logo"></div>
                  <div className="container">
                    <div className="account-profile__item">
                      <div className="account-profile__item-title">
                        {i18n?.name}
                      </div>
                      <div className="account-profile__item-value">
                        {`${data?.firstName} ${data?.lastName}`}
                      </div>
                    </div>
                    <div className="account-profile__item">
                      <div className="account-profile__item-title">
                        {i18n?.businessName}
                      </div>
                      <div className="account-profile__item-value">
                        {data?.companyName}
                      </div>
                    </div>
                    <div className="account-profile__item">
                      <div className="account-profile__item-title">
                        {i18n?.email}
                      </div>
                      <div className="account-profile__item-value">
                        {data?.email}
                      </div>
                    </div>
                    <div className="account-profile__item">
                      <div className="account-profile__item-title">
                        {i18n?.businessZipCode}
                      </div>
                      <div className="account-profile__item-value">
                        {data?.postalCode}
                      </div>
                    </div>
                    <div className="account-profile__item">
                      <div className="account-profile__item-title">
                        {i18n?.accountType}
                      </div>
                      <div className="account-profile__item-value">
                        {data?.custom?.fields?.businessType}
                      </div>
                    </div>
                    {data?.custom?.fields?.businessSubType && (
                      <div className="account-profile__item">
                        <div className="account-profile__item-title">
                          {i18n?.accountSubType}
                        </div>
                        <div className="account-profile__item-value">
                          {data?.custom?.fields?.businessSubType}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          {data?.custom?.fields?.businessType &&
            data?.custom?.fields?.businessType === "Consumer" && (
              <div className="col-12 account-profile__container">
                <div className="account-profile__item">
                  <div className="account-profile__item-title">
                    {i18n?.name}
                  </div>
                  <div className="account-profile__item-value">
                    {`${data?.firstName} ${data?.lastName}`}
                  </div>
                </div>
                <div className="account-profile__item">
                  <div className="account-profile__item-title">
                    {i18n?.email}
                  </div>
                  <div className="account-profile__item-value">
                    {data?.email}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default Profile
